// extracted by mini-css-extract-plugin
export default {"modalBody":"changeOwnerModal_modalBody__iUIdg","bodyContainer":"changeOwnerModal_bodyContainer__1GWHQ","bodyText":"changeOwnerModal_bodyText__h66+T"};